module.exports = __webpack_public_path__ + "static/media/settings-dropdown-arrow.ec36fdd7.svg";